import { render, staticRenderFns } from "./PdfDocuments.vue?vue&type=template&id=ca0b0e54&scoped=true"
import script from "./PdfDocuments.vue?vue&type=script&lang=js"
export * from "./PdfDocuments.vue?vue&type=script&lang=js"
import style0 from "./PdfDocuments.vue?vue&type=style&index=0&id=ca0b0e54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0b0e54",
  null
  
)

export default component.exports